import { getPopularityStatsSales } from '@backmarket/http-api/src/api-specs-checkout/popularity-stats/popularity-stats'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchPopularityStatsSales() {
  const { productId } = useUrlParams()

  const optionalEndpointOptions = getOptionalEndpointTimeoutOptions()

  return useHttpFetch(getPopularityStatsSales, {
    queryParams: { pid: productId },
    ...optionalEndpointOptions,
    dedupe: 'defer',
  })
}
